import { render, staticRenderFns } from "./UnluckBattleConfig.vue?vue&type=template&id=5823ecf4&scoped=true&"
import script from "./UnluckBattleConfig.vue?vue&type=script&lang=js&"
export * from "./UnluckBattleConfig.vue?vue&type=script&lang=js&"
import style0 from "./UnluckBattleConfig.vue?vue&type=style&index=0&id=5823ecf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5823ecf4",
  null
  
)

export default component.exports